import { EXTERNAL_ROUTES } from 'App/constants'

export const handleRedirectToCart = (): void => {
  window.location.assign(EXTERNAL_ROUTES.cart)
}
